export default "/fonts/ReverIcons.woff?b501e83093087dc683e454faaff4cfae";